(function($) {

    $(document).ready(function() {
        var element = $('.scrollup-button');
        var lastAnimation;

        function checkScroll() {
            return $('body').scrollTop() > 450;
        }

        function show() {
            if (element.css('display') !== 'block' && lastAnimation != 'in') {
                element.stop().fadeIn(400);
                lastAnimation = 'in';
            }
        }

        function hide() {

            if (lastAnimation != 'out') {
                element.stop().fadeOut(400);
                lastAnimation = 'out';
            }
        }

        var lastScroll = 0;
        var currentScroll = 0;
        var scrollDirection;

        $(window).scroll(function(e) {
            currentScroll = $('body').scrollTop();
            scrollDirection = currentScroll > lastScroll ? 'down' : 'up';
            lastScroll = currentScroll;

            if (isMobile.any) {
                if (checkScroll() && scrollDirection == 'up') {
                    show();
                } else {
                    hide();
                }
            } else {
                var remainScroll = $('body').prop('scrollHeight') - $('body').scrollTop() - Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                var bottomBreakLine = $('.footer-wrap').height();
                var margin = bottomBreakLine - remainScroll;
                if(margin > 0) {
                    element.css('margin-bottom', margin + 'px');
                } else {
                    element.css('margin-bottom', '0');
                }

                if (checkScroll()) {
                    show();
                } else {
                    hide();
                }
            }
        });

        element.click(function() {
            $(window).scrollTop(0);
            hide();
        })
    });

})(jQuery);
